import sanitizeHtml from 'sanitize-html';
import axios from 'axios';
import { convertPath, CONV_STORAGE, electronConfig, kinoParticipants, room, socket, Video, volumeManager,lockFocus, spacesView, stopMediaPlayers, muteAll, screenShare, pictureInPicture, permissions, onStage, cameraOptionsPreferences, isCameraMuted, getKinoRole, isMicMuted } from '../../libs/roomnew';
import OptionsDots from '../../components/Icons/OptionsDots';
import VolumeIcon from '../../components/Icons/VolumeIcon';
import tippy from 'tippy.js';
import { adjustSlider } from '../functions';
import { emitSpaceChanged } from '../../features/base/spaces/eventDispatcher';
import { setSpaceMenuVisibleEndpoints } from '../../features/base/video-quality/functions';
export default class Space{
    constructor(id,name="Focused Space",type="temporary"){
        this.id=parseInt(id);
        this.name=name;
        this.conv_type=type;
        this.is_private=false;
        this.participants=[];
        this.made_private_by=null;
        this.leftSpaceMenu = $("#left-space-menu");
        this.removeButtonContainer = $("#removeButton")
        this.leftSpaceMenuOptions = $("#left-space-options");
        this.searchBarInput = $("#search-names-input")
        this.hiddenCounter = null;
        this.spaceBodyConainer = null
        this.pinned = false;
        //html elements
        this.container=null;
        this.tiles=null;
        this.volume = 0.05;
        this.dropDownMenu = null
        this.menuTimeOut = 0;
        this.spaceNameIcon = `<svg class="space-name-icon-svg" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 1.875C0.75 1.57663 0.868526 1.29048 1.0795 1.0795C1.29048 0.868526 1.57663 0.75 1.875 0.75H4.125C4.42337 0.75 4.70952 0.868526 4.9205 1.0795C5.13147 1.29048 5.25 1.57663 5.25 1.875V4.125C5.25 4.42337 5.13147 4.70952 4.9205 4.9205C4.70952 5.13147 4.42337 5.25 4.125 5.25H1.875C1.57663 5.25 1.29048 5.13147 1.0795 4.9205C0.868526 4.70952 0.75 4.42337 0.75 4.125V1.875ZM1.875 1.5C1.77554 1.5 1.68016 1.53951 1.60984 1.60984C1.53951 1.68016 1.5 1.77554 1.5 1.875V4.125C1.5 4.22446 1.53951 4.31984 1.60984 4.39016C1.68016 4.46049 1.77554 4.5 1.875 4.5H4.125C4.22446 4.5 4.31984 4.46049 4.39016 4.39016C4.46049 4.31984 4.5 4.22446 4.5 4.125V1.875C4.5 1.77554 4.46049 1.68016 4.39016 1.60984C4.31984 1.53951 4.22446 1.5 4.125 1.5H1.875ZM6.75 1.875C6.75 1.57663 6.86853 1.29048 7.0795 1.0795C7.29048 0.868526 7.57663 0.75 7.875 0.75H10.125C10.4234 0.75 10.7095 0.868526 10.9205 1.0795C11.1315 1.29048 11.25 1.57663 11.25 1.875V4.125C11.25 4.42337 11.1315 4.70952 10.9205 4.9205C10.7095 5.13147 10.4234 5.25 10.125 5.25H7.875C7.57663 5.25 7.29048 5.13147 7.0795 4.9205C6.86853 4.70952 6.75 4.42337 6.75 4.125V1.875ZM7.875 1.5C7.77554 1.5 7.68016 1.53951 7.60983 1.60984C7.53951 1.68016 7.5 1.77554 7.5 1.875V4.125C7.5 4.22446 7.53951 4.31984 7.60983 4.39016C7.68016 4.46049 7.77554 4.5 7.875 4.5H10.125C10.2245 4.5 10.3198 4.46049 10.3902 4.39016C10.4605 4.31984 10.5 4.22446 10.5 4.125V1.875C10.5 1.77554 10.4605 1.68016 10.3902 1.60984C10.3198 1.53951 10.2245 1.5 10.125 1.5H7.875ZM0.75 7.875C0.75 7.57663 0.868526 7.29048 1.0795 7.0795C1.29048 6.86853 1.57663 6.75 1.875 6.75H4.125C4.42337 6.75 4.70952 6.86853 4.9205 7.0795C5.13147 7.29048 5.25 7.57663 5.25 7.875V10.125C5.25 10.4234 5.13147 10.7095 4.9205 10.9205C4.70952 11.1315 4.42337 11.25 4.125 11.25H1.875C1.57663 11.25 1.29048 11.1315 1.0795 10.9205C0.868526 10.7095 0.75 10.4234 0.75 10.125V7.875ZM1.875 7.5C1.77554 7.5 1.68016 7.53951 1.60984 7.60983C1.53951 7.68016 1.5 7.77554 1.5 7.875V10.125C1.5 10.2245 1.53951 10.3198 1.60984 10.3902C1.68016 10.4605 1.77554 10.5 1.875 10.5H4.125C4.22446 10.5 4.31984 10.4605 4.39016 10.3902C4.46049 10.3198 4.5 10.2245 4.5 10.125V7.875C4.5 7.77554 4.46049 7.68016 4.39016 7.60983C4.31984 7.53951 4.22446 7.5 4.125 7.5H1.875ZM6.75 7.875C6.75 7.57663 6.86853 7.29048 7.0795 7.0795C7.29048 6.86853 7.57663 6.75 7.875 6.75H10.125C10.4234 6.75 10.7095 6.86853 10.9205 7.0795C11.1315 7.29048 11.25 7.57663 11.25 7.875V10.125C11.25 10.4234 11.1315 10.7095 10.9205 10.9205C10.7095 11.1315 10.4234 11.25 10.125 11.25H7.875C7.57663 11.25 7.29048 11.1315 7.0795 10.9205C6.86853 10.7095 6.75 10.4234 6.75 10.125V7.875ZM7.875 7.5C7.77554 7.5 7.68016 7.53951 7.60983 7.60983C7.53951 7.68016 7.5 7.77554 7.5 7.875V10.125C7.5 10.2245 7.53951 10.3198 7.60983 10.3902C7.68016 10.4605 7.77554 10.5 7.875 10.5H10.125C10.2245 10.5 10.3198 10.4605 10.3902 10.3902C10.4605 10.3198 10.5 10.2245 10.5 10.125V7.875C10.5 7.77554 10.4605 7.68016 10.3902 7.60983C10.3198 7.53951 10.2245 7.5 10.125 7.5H7.875Z" fill="#F7A95D"></path></svg>`
        this.doubleClickOccurred = false
        this.closeDropDownMenuIcon = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 329.269 329" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M194.8 164.77 323.013 36.555c8.343-8.34 8.343-21.825 0-30.164-8.34-8.34-21.825-8.34-30.164 0L164.633 134.605 36.422 6.391c-8.344-8.34-21.824-8.34-30.164 0-8.344 8.34-8.344 21.824 0 30.164l128.21 128.215L6.259 292.984c-8.344 8.34-8.344 21.825 0 30.164a21.266 21.266 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25l128.21-128.214 128.216 128.214a21.273 21.273 0 0 0 15.082 6.25c5.46 0 10.922-2.09 15.082-6.25 8.343-8.34 8.343-21.824 0-30.164zm0 0" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>`

        this.lastVolume = 0.05;
        this.sanitizeOptions = {
            allowedTags: [],
            allowedAttributes: {
                span: [],
                img: [],
            },
            allowedSchemesByTag: {
                img: [],
            },
        };
        this.removeButtonIcon = `<svg width="18px" height="20px" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.8203 2.34375H12.3365L11.9557 1.20164C11.8392 0.851549 11.6155 0.547032 11.3162 0.331327C11.0168 0.115622 10.6572 -0.000307081 10.2882 6.1091e-07H7.28988C6.92089 -0.000244307 6.56118 0.1157 6.26179 0.331388C5.9624 0.547077 5.73852 0.851557 5.62191 1.20164L5.24148 2.34375H1.75781C0.788516 2.34375 0 3.13227 0 4.10156V5.27344C0 5.92609 0.587539 5.85938 1.21809 5.85938H16.9922C17.3161 5.85938 17.5781 5.59731 17.5781 5.27344V4.10156C17.5781 3.13227 16.7896 2.34375 15.8203 2.34375ZM6.47707 2.34375L6.73371 1.57242C6.77261 1.45571 6.84727 1.35421 6.9471 1.28232C7.04693 1.21042 7.16686 1.17178 7.28988 1.17188H10.2882C10.5406 1.17188 10.7643 1.33266 10.8439 1.57242L11.1008 2.34375H6.47707ZM1.31508 7.10938L2.24934 18.4013C2.3323 19.3128 3.08477 20 3.99973 20H13.5784C14.4934 20 15.2459 19.3128 15.3294 18.3961L16.2631 7.10938H1.31508ZM5.85938 17.0703C5.85938 17.8427 4.6875 17.8459 4.6875 17.0703V8.86719C4.6875 8.09481 5.85938 8.09164 5.85938 8.86719V17.0703ZM9.375 17.0703C9.375 17.8427 8.20312 17.8459 8.20312 17.0703V8.86719C8.20312 8.09481 9.375 8.09164 9.375 8.86719V17.0703ZM12.8906 17.0703C12.8906 17.8427 11.7188 17.8459 11.7188 17.0703V8.86719C11.7188 8.54332 11.9808 8.28125 12.3047 8.28125C12.6286 8.28125 12.8906 8.54332 12.8906 8.86719V17.0703Z" fill="white"/>
        </svg>`
        this.isLeftSideMenuOpen=false
        this.spaceJoinTimers={};
        this.micMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M265.403 88.2228C264.31 53.2236 235.217 25.0055 199.999 25.0055C163.906 25.0055 134.375 54.536 134.375 90.6289V200.001C134.375 205.907 135.25 211.376 136.781 216.845L265.403 88.2228Z" fill="#FF3D00"/>
        <path d="M199.999 265.625C236.092 265.625 265.622 236.094 265.622 200.001V149.843L371.801 43.6644C376.066 39.3989 376.066 32.4647 371.801 28.1991C367.535 23.9336 360.601 23.9336 356.336 28.1991L28.2183 356.316C23.9309 360.582 23.9309 367.516 28.1964 371.782C32.4619 376.069 39.3743 376.069 43.6617 371.804L131.335 284.131C147.565 297.19 167.253 306.049 189.061 308.28V364.06C189.061 370.185 193.874 374.997 199.999 374.997C206.123 374.997 210.936 370.185 210.936 364.06V308.28C266.06 302.593 309.371 256.656 309.371 200.001V189.064C309.371 182.939 304.559 178.127 298.434 178.127C292.309 178.127 287.497 182.939 287.497 189.064V200.001C287.497 248.344 248.341 287.499 199.999 287.499C179.874 287.499 161.5 280.324 146.603 268.862L162.112 253.353C172.852 260.987 185.977 265.625 199.999 265.625V265.625Z" fill="#FF3D00"/>
        <path d="M119.501 234.126C114.907 223.626 112.501 212.032 112.501 200.001V189.064C112.501 182.939 107.688 178.127 101.563 178.127C95.4386 178.127 90.6262 182.939 90.6262 189.064V200.001C90.6262 218.376 95.2199 235.438 103.095 250.531L119.501 234.126Z" fill="#FF3D00"/>
        </svg>`;
        this.cameraMutedIcon = `<svg width="15px" height="15px" viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M46.4372 307.202L262.121 91.5075C259.715 90.8513 257.309 90.6325 254.684 90.6325H57.812C39.656 90.6325 25 105.289 25 123.446V276.576C25 290.795 33.9686 302.827 46.4372 307.202Z" fill="#FF3D00"></path><path d="M359.245 113.602L287.496 149.478V127.974L371.801 43.6654C376.066 39.3997 376.066 32.4651 371.801 28.1993C367.535 23.9336 360.601 23.9336 356.335 28.1993L28.2156 356.335C23.95 360.6 23.95 367.535 28.2156 371.801C32.4811 376.066 39.4154 376.066 43.6809 371.801L106.089 309.389H254.684C272.84 309.389 287.496 294.733 287.496 276.576V250.544L359.245 286.42C363.292 288.148 367.032 287.689 369.745 285.982C373.026 283.795 374.995 280.295 374.995 276.576V123.446C374.995 119.727 373.026 116.227 369.745 114.04C366.682 112.071 362.526 111.852 359.245 113.602V113.602Z" fill="#FF3D00"></path></svg>`
    };

    isLobby(){
        return this.id===-1;
    }

    isPinned(){
        return this.pinned;
    }

    setPinned(pinned) {
        this.pinned = pinned;
    }

    async storePinSpace(){
        this.setPinned(true);
        const Token = await electronConfig()
        axios.post(convertPath(`/spaces/pin`),{
            kino_id:ROOM_NAME,
            guest_id:GUEST_ID,
            space_id:this.id,
        },Token)
            .then((res) => {
                // console.log("Pinned space",res);
            }).catch(err=>{
                console.error("Pinned space error",err);
                // reject(err);
            })
    }
    async storeUnpinSpace(){
        this.setPinned(false);
        const Token = await electronConfig()
        axios.post(convertPath(`/spaces/unpin`),{
            kino_id:ROOM_NAME,
            guest_id:GUEST_ID,
            space_id:this.id,
        },Token)
            .then((res) => {
                // console.log("Pinned space",res);
            }).catch(err=>{
                console.error("Pinned space error",err);
                // reject(err);
            })
    }

    participantJoined(pid){
        try {
           let p = kinoParticipants.get(pid);
           try {
                //clear previous timers set for this user
                if(Object.keys(this.spaceJoinTimers).includes(pid)){
                    clearTimeout(this.spaceJoinTimers[pid])
                }
           } catch (error) {}

           if(!p){
                //if participant is not added yet to the kino wait 1 second and try again
                console.error("Participant not joined yet, waiting",pid);
                if(this.spaceJoinTimers[pid] === undefined){
                    this.spaceJoinTimers[pid]=setTimeout(() => {
                        this.participantJoined(pid);
                    }, 1000);
                }
                return
           }
           if(p.getSpaceId() != this.id){
              this.addParticipant(pid,true);
              if(p.local){
                this.joinAsLocalUser(p);
              }else{
                this.joinRemoteUser(p);
              }
            //   CONV_STORAGE.changeConversationOrder(this.id);
           }
        } catch (error) {
            console.error("participantJoined error",error);
        }
    };
    participantLeft(pid){
        try {

            let p = kinoParticipants.get(pid);
            console.log(`Participant left `,p)
            if(!p.local){
                try {
                    $(`#unmute-request-${pid}`).remove();
                    console.log(`Checking if ${p.getName()} is presenter`,Video.presenter.isPresenter(p.id))
                    if (Video.presenter.isPresenter(p.id)) {
                        Video.presenter.removePresenter(true);
                    }
                        Video.presenter.canMakePresenterActive();
                    } catch (err) {
                            console.error("presenter view error", err);
                    }
                p.removeFromSpace(this.id);
                if(CONV_STORAGE.myConversation == this.id){
                   this.participantLeftMySpace(p);
                }else{
                    this.participantLeftAnotherSpace(p);
                }
                if(Video.videos[p.id] && Video.videos[p.id].isVideoMuted() && !Video.videos[p.id].noCameraLayer.hasClass('d-none')){
                    Video.videos[p.id].onVideoMuted();
                }
                emitSpaceChanged(pid,null,this.id)
            }else{
                this.container.removeClass("my-space");
                p.removeFromSpace(this.id);
                this.removeFocusFromParticipants();
                CONV_STORAGE.hideBanner();
            }
            this.renderSpaceTiles();
            spacesView.renderLobbySpaceTiles();
            // CONV_STORAGE.changeConversationOrder(this.id);
            this.endFocusedSpace();
        } catch (error) {
            console.error("participantLeft error",error);
        }
    };
    clearParticipants(){
        let pids=this.participants;
        pids.forEach(pid=>{
            try {
                let p = kinoParticipants.get(pid);
                if(!p.local){
                    console.log(`Clearing participant ${p.getName()} from space ${this.id}`);
                    try {
                        console.log(`Checking if ${p.getName()} is presenter`,Video.presenter.isPresenter(p.id))
                        if (Video.presenter.isPresenter(p.id)) {
                            Video.presenter.removePresenter(true);
                        }
                            Video.presenter.canMakePresenterActive();
                        } catch (err) {
                            console.error("presenter view error", err);
                        }
                    p.removeFromSpace(this.id);
                    if(CONV_STORAGE.myConversation == this.id){
                       this.participantLeftMySpace(p);
                    }else{
                        this.participantLeftAnotherSpace(p);
                    }
                    p.removeSpaceThumbnail();
                    if(Video.videos[p.id] && Video.videos[p.id].isVideoMuted() && !Video.videos[p.id].noCameraLayer.hasClass('d-none')){
                        Video.videos[p.id].onVideoMuted();
                    }
                    this.endFocusedSpace(true);
                }
                if(this.isPrivate() && this.made_private_by!='moderator' && this.id != CONV_STORAGE.myConversation){
                    this.is_private=false;
                    this.made_private_by=null;
                }
            } catch (error) {

            }
        });
    };
    endFocusedSpace(silently=false){
        if(this.conv_type!="pinned"){
            this.closeLeftSpaceMenu();
            console.log("Should end this focused space with participants ",this.participants);
            if(this.participants.length == 1){
                if(this.participants[0] == room.myUserId() && !CONV_STORAGE.leaving){
                    if(permissions.leaveFallbackAssigned()
                        && permissions.initialSpace()
                        && CONV_STORAGE.spaceExists(permissions.initialSpace())
                        && permissions.initialSpace() != CONV_STORAGE.myConversation
                        ){
                            CONV_STORAGE.joinSpace(permissions.initialSpace()).then(()=>{
                                CONV_STORAGE.destroySpace(this.id);
                            })
                        }else{
                            CONV_STORAGE.leaveSpace(false,volumeManager.muteVolumeOverwrite ? 0 : false,silently).then(()=>{
                                CONV_STORAGE.destroySpace(this.id);
                            })
                        }
                }
            }else if(this.participants.length==0){
                CONV_STORAGE.destroySpace(this.id);
            }
        }
    };
    removeFocusFromParticipants(){
        this.participants.forEach(pid=>{
            try {
                let p=kinoParticipants.get(pid);
                if(!p.local){
                   kinoParticipants.get(pid).setAsUnfocused();
                }

            } catch (error) {

            }
        });
    };
    participantLeftMySpace(user){
        console.log(`${user.getName()} left my space ${CONV_STORAGE.myConversation},Focused ${Object.keys(Video.focused).length}`)
        user.setAsUnfocused();
        if(!Video.isTileView){
            user.moveToSide();
        }
        screenShare.popup.onUserLeft(user.id);
        pictureInPicture.updateUsers(kinoParticipants.inSameSpace());
        CONV_STORAGE.updateBanner();
        if(this.participants.length==1){
            Video.localVideoMaximize();
        }
        if(this.isPrivate()){
            CONV_STORAGE.private && CONV_STORAGE.private.sendPrivateStreamIds();
        }
        Video.isFocusedSafeView();
        Video.isOnlyOne();
        Video.resizeMainVideos();
    };

    participantLeftAnotherSpace(user){
        console.log(`${user.getName()} left another space from, my space ${CONV_STORAGE.myConversation},Focused ${Object.keys(Video.focused).length}`)
        if(Video.isTileView){
            user.moveToMain()
        }else if(!CONV_STORAGE.myConversation && Object.keys(Video.focused).length==0){
            user.moveToMain();
        }else{
            user.moveToSide();
        }
        if(!CONV_STORAGE.myConversation){
            screenShare.popup.onUserJoined(user);
            pictureInPicture.updateUsers(kinoParticipants.inSameSpace());
        }
        if(this.isPrivate()){
            const currentSpace=user.getSpaceId();
            if(currentSpace && currentSpace != this.id){
                const space=CONV_STORAGE.getSpace(currentSpace);
                if(space && !space.isPrivate()){
                    Video.videos[user.id].thumbnail = undefined;
                    CONV_STORAGE.updateThumbnailImage(user.id);
                    CONV_STORAGE.updateConversationThumbnail(user.id);
                }
            }else{
                Video.videos[user.id] && (Video.videos[user.id].thumbnail = undefined);
                CONV_STORAGE.updateThumbnailImage(user.id);
                CONV_STORAGE.updateConversationThumbnail(user.id);
            }
        }
        Video.isFocusedSafeView();
        Video.isOnlyOne();
        Video.resizeMainVideos();
    };

    joinAsLocalUser(user,setVolume=false){
        try {
            this.container.addClass("my-space");
            // this.setVolume(1);
            CONV_STORAGE.myConversation=this.id;
            console.log(`check lobby volume ${spacesView.getVolume()} || ${volumeManager.masterVolume}`)
            // if(spacesView.getVolume() != 0.05){
            //     spacesView.setVolume(volumeManager.masterMuted ? 0 : 0.05)
            // }
            if(room.getLocalAudioTrack() && !room.getLocalAudioTrack().isMuted()){
                muteAll.checkMuteAllPolicy();
            }
            muteAll.onUserSpaceChanged();
            console.log("Adding participants in main screen");
            kinoParticipants.addInMainScreen(this.participants,true);
            if(this.isPrivate()){
                this.participants.forEach(pid=>{
                    if(pid==room.myUserId()){return}
                    CONV_STORAGE.updateThumbnailImage(pid);
                    CONV_STORAGE.updateConversationThumbnail(pid);
                });
            }
            if(this.participants.length==1){
                Video.localVideoMaximize();
            }else if(this.participants.length > 1){
                Video.localVideoMinimize();
            }
            if(setVolume){
                emitSpaceChanged(room.myUserId(),this.id,null);
            }
            Video.focusedView();
            Video.isFocusedSafeView();
            Video.isOnlyOne();
            Video.resizeMainVideos();

            CONV_STORAGE.updateBanner();
            CONV_STORAGE.showBanner();
        } catch (error) {
            console.error("joinAsLocalUser error ",error);
        }
    };

    joinRemoteUser(user,unfocus=true){
        console.log(`Join remote user in space ${this.id}, my space${CONV_STORAGE.myConversation}`);
        Video.notifications.find(`.${user.id}-notification`).remove();
        if (CONV_STORAGE.invitesTimeout[user.id] !== undefined) {
            clearTimeout(CONV_STORAGE.invitesTimeout[user.id]);
        }
        $(`#unmute-request-${user.id}`).remove();
        try {
            if (Video.presenter.isPresenter(user.id)) {
                Video.presenter.removePresenter(true);
            }
            Video.presenter.canMakePresenterActive();
        } catch (err) {
            console.error("presenter view error", err);
        }

        if(this.id==CONV_STORAGE.myConversation){
            console.log("Joined in my space");
            if(Video.focused[user.id]){
                delete Video.focused[user.id];
            }
            if(this.participants.length == 2 && Video.isLocalMaximized){
                Video.localVideoMinimize();
            }
            //joined my space
            user.moveToMain();
            user.setAsFocused();
            screenShare.popup.onUserJoined(user);
            pictureInPicture.updateUsers(kinoParticipants.inSameSpace());

            if(this.isPrivate()){
                CONV_STORAGE.private && CONV_STORAGE.private.sendPrivateStreamIds();
                CONV_STORAGE.updateThumbnailImage(user.id);
                CONV_STORAGE.updateConversationThumbnail(user.id);
            }
            CONV_STORAGE.updateBanner();
        }else{
            user.setAsUnfocused();
            if(Video.focused[user.id] && unfocus){
                Video.unFocusVideo(user.id,false);
                CONV_STORAGE.showNotification(Video.conversationIcon,"JOIN_CONVERSATION", {participant: user.id,conversation_id: this.id,displayName:user.getName()});
            }
            if(!CONV_STORAGE.myConversation){
                pictureInPicture.updateUsers(kinoParticipants.inSameSpace());
                screenShare.popup.onUserLeft(user.id);
            }
            if(!Video.isTileView){
                user.moveToSide();
            }else{
                user.moveToMain();
            }
            if(this.isPrivate()){
                CONV_STORAGE.updateThumbnailImage(user.id,true);
                CONV_STORAGE.updateConversationThumbnail(user.id,true);
            }
        }
        emitSpaceChanged(user.id,this.id,null)
        Video.isFocusedSafeView();
        Video.isOnlyOne();
        Video.resizeMainVideos();
    };

    renderMenuParticipantThumbnail(participant){
        console.log(`Function: createSpaceThumbnail(participant:${participant.id},space_id:${this.id})`);

        console.log("PARTICIPANT",participant);

        // if(Video.isLobbyView && participant.conversation_id!=c.myConversation && (participant.participant != room.myUserId() || room==null)){
        //     Video.speaker.removeSpeaker(participant.participant);
        //     Video.removeParticipantFromLobby(participant.participant);
        // }
        // this.removeLobbyThumbnail();
        let videoElement=document.createElement('video');
        videoElement.autoplay=1;
        videoElement.muted=1;
        videoElement.setAttribute('pid',participant.id);
        videoElement.classList.add('h-100','video-center','video-preview','conversation-video-player');
        if(participant.id == room.myUserId() && cameraOptionsPreferences.camera_flip){
            videoElement.classList.add('flipVideoX');
        }
        // if (participant.participant == room.myUserId()) {
        //     c.myConversation = participant.conversation_id;
        //     c.conversations[c.myConversation].htmlElement.addClass(
        //         "my-conversation"
        //     );
        // }
        let previewVideo = participant.getVideo();

        if (previewVideo) {
            videoElement.srcObject = previewVideo.stream;
            videoElement.oncanplay = function () {
                videoElement.play();
            };
        }

        const prviteSpaceIcon = $("<div />", {
            class: "private-space-icon-conatiner",
            html: `<svg width="15px" height="17px" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_2358_436)">
            <path d="M31.3189 18.233C30.865 17.8352 30.3143 17.6365 29.6659 17.6365H28.8885V13.5453C28.8885 10.9318 27.8194 8.68764 25.6804 6.81263C23.5415 4.93754 20.9818 4 17.9999 4C15.0181 4 12.4578 4.93754 10.3191 6.81255C8.18013 8.68764 7.11096 10.9317 7.11096 13.5453V17.6365H6.33328C5.68535 17.6365 5.13429 17.8352 4.68054 18.233C4.22679 18.6304 4 19.1135 4 19.682V31.9546C4 32.5226 4.22688 33.0058 4.68054 33.4037C5.13429 33.801 5.68535 34 6.33328 34H29.6665C30.3149 34 30.8655 33.8013 31.3195 33.4037C31.7728 33.0058 32 32.5226 32 31.9546V19.6818C32.0003 19.1137 31.7728 18.6307 31.3189 18.233ZM24.222 17.6365H11.7777V13.5453C11.7777 12.0397 12.3855 10.7541 13.6007 9.68898C14.8161 8.62368 16.2824 8.09114 18.0001 8.09114C19.718 8.09114 21.184 8.62361 22.3995 9.68898C23.6144 10.7541 24.222 12.0397 24.222 13.5453V17.6365Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_f_2358_436" x="0" y="0" width="36" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_2358_436"/>
            </filter>
            </defs>
            </svg>
            `
        })

        const privateSpaceTitle = $("<h6 />", {
            html: `In Private Space`
        })

        participant.privateSpaceLayer = $("<div/>", {
            class: `private-space-layer ${this.is_private || "d-none"}`,
            html: [prviteSpaceIcon,privateSpaceTitle]
        })

        let displayName = $('<div/>', {
            class: `participant-name ellipsis noselect display-name-${participant.id}`,
            html: participant.local ? participant.getName() + " (me)" : participant.getName()
        });

        let noCameraCirce=$('<div/>',{
            class: 'no-cam-layer-background mb-2',
            html: Video.noCameraIcon
        });


        participant.menuNoCameraLayerThumb=$("<div/>",{
            class:`no-camera-spaces-thumb d-none`,
            html:[noCameraCirce]
        });

        let vidcontainer = $("<div/>", {
            class: "videoContainer participant-container text-center",
            html: [videoElement,participant.menuNoCameraLayerThumb],
        });

        const spaceThumbnail = $("<div/>", {
            style: `height:${spacesView.getTileHeight()}px;width:${spacesView.getTileWidth()}px;`,
            class: `participant-video-container-dropw-down pid_${participant.id}`,
            'space-id': this.id,
            html: [vidcontainer, participant.privateSpaceLayer],
        });
        //show no camera layer if video is muted
        if(Video.videos[participant.id]){
            if(Video.videos[participant.id].isVideoMuted()){
                Video.videos[participant.id].onVideoMuted();
            }
        }else if(participant.id==room.myUserId() && isCameraMuted()){
            participant.menuNoCameraLayerThumb.removeClass('d-none');
        }

        return spaceThumbnail
    }

    addParticipant(id,addThumbail=false){
        try {
            if(kinoParticipants.exists(id)){
                console.log("adding participant in space");
                let participantsUnique=this.participants.filter(pid=>pid!=id);
                participantsUnique.push(id);
                this.participants=participantsUnique;
                if(addThumbail && kinoParticipants.exists(id)){
                    kinoParticipants.get(id).addOnSpace(this.id);
                }
                this.renderSpaceTiles();
            }
            spacesView.renderLobbySpaceTiles();
        } catch (error) {
            console.log("addParticipant err", error)
        }
    };

    renderSpaceTiles(){
        const allPids = this.participants.filter(id=>kinoParticipants.exists(id));
        const visibleCount = this.getVisibleCount();
        const firstPids = allPids.slice(0, visibleCount);
        const leftOut = allPids.slice(visibleCount,allPids);
        console.trace("Rendering Space tiles, visible ",visibleCount," hidden ",leftOut)
        this.tiles.html('');
        firstPids.forEach((pid)=>{
            kinoParticipants.get(pid).createSpaceThumbnail(this.id);
        })
        leftOut.forEach(pid=>{
            kinoParticipants.get(pid).removeSpaceThumbnail();
        })
        if(this.getHiddenCount() > 0){
            this.renderHiddenCountBox(this.getHiddenCount())
        }
    }

    renderHiddenCountBox(count){
        const counter = $("<h5/>",{
            class:'text-white mb-0 space-hidden-counter-text',
            html:'+'+count
        });
        if(this.hiddenCounter){
            this.hiddenCounter.remove();
        }
        this.hiddenCounter = $("<div/>",{
            class:`participant-video-container ${this.isPrivate() ? "space-hidden-counter-ps" : "space-hidden-counter"}`,
            style: `height:${spacesView.getTileHeight()}px;width:${spacesView.getTileWidth()}px;`,
            html:counter
        })

        this.tiles.append(this.hiddenCounter);

    }

    getVisibleCount(){
        const participants = this.participants.filter(id=>kinoParticipants.exists(id)).length;
        if(spacesView.isOpen() && !spacesView.isWindowSmall()){
            if(participants  > spacesView.maxTilesExpanded){
                return spacesView.maxTilesExpanded - 1;
            }
            return spacesView.maxTilesExpanded
        }else{
            if(participants  > spacesView.maxTilesCollapsed){
                return spacesView.maxTilesCollapsed - 1;
            }
            return spacesView.maxTilesCollapsed
        }
    }

    getHiddenCount(){
        const participants = this.participants.length;
        if(spacesView.isOpen() && !spacesView.isWindowSmall()){
            if(participants  > spacesView.maxTilesExpanded){
                return (participants - spacesView.maxTilesCollapsed) + 1;
            }
        }else{
            if(participants  > spacesView.maxTilesCollapsed){
                return (participants - spacesView.maxTilesCollapsed) + 1;
            }
        }
        return 0
    }

    removeParticipant(id){
        this.participants=this.participants.filter(pid=>pid!=id);
    }

    setParticipants(participants,newFocusedSpace=false){
        if(newFocusedSpace){
            let myId=participants.find(pid=>pid==room.myUserId());
            participants=participants.filter(pid=>pid!=room.myUserId());
            if(myId){
                participants.unshift(myId);
                Video.unFocusAll(participants);
            }
        }
        participants.forEach(newp => {
            let pid='';
            if(typeof newp == 'string'){
                pid=newp;
            }else{
                pid=newp.participant;
            }

            let p = kinoParticipants.get(pid);
           if(p && p.getSpaceId() != this.id){
              this.addParticipant(pid,true);
              if(p.local){
                this.joinAsLocalUser(p,true);
              }else{
                this.joinRemoteUser(p,true);
              }

           }
        });
    };

    setPrivate(isprivate,made_private_by=null){
        this.is_private=isprivate;
        this.made_private_by=made_private_by;
        const localPrivateSpaceLayer = kinoParticipants.me().privateSpaceLayer
        if(this.privateSpaceLayer){
        if(isprivate){
            this.privateSpaceLayer.removeClass("d-none")
        }else {
            this.privateSpaceLayer.addClass("d-none")
        }
        }
        if(localPrivateSpaceLayer){
            if(isprivate){
                localPrivateSpaceLayer.removeClass("d-none")
            }else {
                localPrivateSpaceLayer.addClass("d-none")
            }
        }
        if(this.hiddenCounter){
            isprivate && this.hiddenCounter.removeClass('space-hidden-counter').addClass('space-hidden-counter-ps')
            isprivate || this.hiddenCounter.removeClass('space-hidden-counter-ps').addClass('space-hidden-counter')
        }
    };

    isPrivate(){
        return this.is_private;
    }


    makeNameEditable() {
        if (this.id !== CONV_STORAGE.myConversation && !permissions.hasSpacesManager()) {
            return;
        }
        if (!permissions.hasSpacesManager() && this.conv_type == "pinned") {
            return;
        }
        this.spaceHeaderContent.addClass("d-none")
        this.spaceInput.removeClass("d-none")
        this.spaceInput.focus()
        this.spaceInput.val(this.name)
        this.isEscClicked = false
    };

    cancelNameChange() {
        this.isSaving=false;
        this.spaceHeaderContent.removeClass("d-none")
        this.spaceInput.addClass("d-none")
    };

    selectText(element) {
        var text = element[0];
        if (document.body.createTextRange) {
            var range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else {
            var selection = window.getSelection();
            var range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
        }
    };

    saveName(name=false) {
        if (permissions.hasSpacesManager() || (this.conv_type=="temporary" && CONV_STORAGE.myConversation == this.id)) {
            let conv_name = name ? name : this.spaceInput.val()
            let santize_conv_name = sanitizeHtml(conv_name, this.sanitizeOptions)
            if (santize_conv_name == "" || !santize_conv_name.trim().length ) {
                santize_conv_name = "Pinned Space";
            }
            this.isSaving = false;
            this.spaceName.text(santize_conv_name)
            this.spaceNameHeading.text(santize_conv_name)
            this.spaceHeaderContent.removeClass("d-none")
            this.spaceInput.addClass("d-none")
            if($("#left-space-menu").hasClass("open") && $("#left-space-menu").attr("space-id") == this.id){
                $("#left-menu-space-name").html(santize_conv_name)
            }
            this.setName(santize_conv_name);
            if(this.isPinned()){
                spacesView.orderPinnedSpaces();
            }else{
                spacesView.orderNonPinnedSpaces();
            }
        } else {
            this.cancelNameChange();
        }
    };

    async setName(name) {
        let c = this;
        this.name = name;
        axios.post(convertPath(`/conversation/name/${this.id}`), {
                name: name,
            }, await electronConfig())
            .then((res) => {
                if (res.data.success === true) {
                    socket.sendConversationNameChanged(this.id, CONV_STORAGE.room_id, name);
                    return;
                }
            })
            .catch((err) => {
                console.error("update name error", error);
            });
        CONV_STORAGE.updateBanner();
    };

    onJoinSpace(){
        if(Video.isDisconnected || (CONV_STORAGE.myConversation == this.id)){
            return;
        }
        spacesView.hideSpaceView();
        if(onStage.isActive()){
            onStage.showLockOnStageActiveNotification();
            return;
        }
        if(lockFocus.isLocked() && !permissions.hasSpacesLock()){
            lockFocus.showLockFocusNotification();
            return;
        }

        if(this.isPrivate() && permissions.shouldRequestToJoinPrivateSpace()){
            CONV_STORAGE.showNotification('<i class="fas fa-lock fa-lg" style="color:#fff"></i>',"CONVERSATION_IS_PRIVATE", { conversation_id: this.id });
            return;
        }
        CONV_STORAGE.joinSpace(this.id);
    };

    addEnterButtonInTheLeftSideMenu () {
        const enterButton = $("<button/>", {
            class: "btn btn-blur enter-btn",
            html: "Enter Space",
            id: "enterBtnLeftSide"
        }).on("click", () => {
            if($("#left-space-menu").attr("space-id") !== "lobby"){
                this.onJoinSpace()
            }else {
            if(CONV_STORAGE.myConversation){
                CONV_STORAGE.leaveSpace()
            }
            }
            this.closeLeftSpaceMenu()
        })

        $(".left-side-menu-enter-button").html(enterButton)
    }

    openLeftSpaceMenu(){
        this.isLeftSideMenuOpen = !this.isLeftSideMenuOpen
        this.addEnterButtonInTheLeftSideMenu()
        this.closeLeftSpaceMenu();
        $("#left-menu-space-name").html(this.getName())
        this.renderLeftMenuParticipants(this.leftSpaceMenu);
        this.leftSpaceMenu.addClass('open').removeClass('d-none');
        this.leftSpaceMenu.attr('space-id',this.id);

        Video.efss.inViewportSpaceMenu(false);
        if(this.isLobby()){
            this.removeButtonContainer.remove()
        }else {
            if(permissions.hasSpacesManager()){
                this.renderRemoveSpaceButton()
            }
        }
    }

    renderRemoveSpaceButton(){
            this.buttonTitle = $("<h6/>", {
                class: "text-white/95 mb-0 ml-2",
                html: "Delete space"
            });

            this.removeSpaceButton = $("<button/>", {
                class: "btn-blur box-header d-flex justify-content-center align-self-center red-btn-shadow",
                html: [this.removeButtonIcon, this.buttonTitle]
            }).on("click", () => {
                this.unPinConversation();
            });

            this.removeButtonContainer.html(this.removeSpaceButton);
    }

    openDropDownMenu(){
        this.spaceNameHeading.html(this.getName())
        if(this.dropDownSpaceOption.hasClass("d-none")){
            $(".drop-down-space-menu").addClass("d-none")
            this.dropDownSpaceOption.removeClass("d-none")
            spacesView.expandedOpenedMenu=`#dropDownMenuOption-${this.id}`;
            this.createDropDownMenuOptions()
            Video.efss.inViewportSpaceMenu(false);
        } else {
            this.dropDownSpaceOption.addClass("d-none")
            spacesView.expandedOpenedMenu=null;
            setSpaceMenuVisibleEndpoints([],true)
            setTimeout(() => {
                Video.efss.inViewPortConversations();
            }, 200);
        }
    }

    closeLeftSpaceMenu(){
        this.leftSpaceMenu.removeClass('open').addClass('d-none');
        this.leftSpaceMenu.removeAttr('space-id');
        setSpaceMenuVisibleEndpoints([],true)
    }

    toggleLeftMenu(){
        if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
            this.openDropDownMenu();
        } else {
            if (this.leftSpaceMenu.hasClass('open')){
                if(this.leftSpaceMenu.attr('space-id') == this.id){
                    this.closeLeftSpaceMenu();
                    return
                }
            }
            this.openLeftSpaceMenu();
        }
    }

    renderLeftMenuParticipants(){
        const PARTICIPANTS=[];
        for (let index = 0; index < this.participants.length; index++) {
            const participants = this.participants
            const pid = this.participants[index];
            let p = kinoParticipants.get(pid);
            const participant = $("<h6/>",{
                class:'text-white/95 mb-4 space-options-item ellipsis',
                html:p.getName()+`${p.local ? ' (me)':''}`
            })

            const participantThumbnail = $("<div/>", {
                class: "participant-video-container",
                html: this.renderMenuParticipantThumbnail(p)
            })
            const email = p.local ? localStorage.getItem("displayEmail") : p.email;
            const role = p.local ? getKinoRole(): p.role;
            const participantEmail = $("<h6/>", {
                class: "participant-information ellipsis",
                attr: {
                    "data-original-title": email,
                    "data-placement": "top",
                    "title": "",
                    "data-toggle": "tooltip"
                }
            });

            if (email) {
                participantEmail.html(`Email: <a target="_blank" href="mailto:${email}">${email}</a>`);
            } else {
                participantEmail.text("Email: No email");
            }

            const participantRole = $("<h6/>", {
                html: `Role: ${role}`,
                class: "participant-information participant-role"
            })


            const menuContent = $("<div/>", {
                class: "menu-content",
            })

            const actions = $('<span/>',{
                class: "option-icon-container",
                html:  OptionsDots,
            }).on("click", () => {
                if (menuContent.is(":visible")) {
                    menuContent.addClass("fadeOut")
                    setTimeout(() => {
                        menuContent.removeClass("fadeOut")
                        menuContent.remove();
                        participantMenuContentContainer.html([participantEmail,participantRole])
                      }, 400);

                } else {
                    if(!p.local){
                        participantMenuContentContainer.html(menuContent)
                        Video.renderParticipantMenu(p.id, menuContent,p)
                    }else{
                        participantMenuContentContainer.html(menuContent)
                        Video.renderLocalParticipantMenu(menuContent)
                    }
                }
            })

            let isCameraMutedOnTile = p.local ? isCameraMuted() : Video.videos[p.id].isVideoMuted()
            let isMicMutedOnTile = p.local ? isMicMuted() :  Video.videos[p.id].hasMicMuted


            let micMuted = $('<div/>', {
                class: `in-video-mic-muted mic-status-${p.local ? "local" :p.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
                html: this.micMutedIcon
            })

            let cameraMuted = $('<div/>',{
                class: `in-video-camera-muted camera-status-${p.local ? "local" :p.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,

                html: this.cameraMutedIcon
            });

            let indicatiors = $("<div/>", {
                class: "space-menu-tiles-indicators",
                html: [micMuted,cameraMuted]
            }
            )

            const participantItem = $("<div/>",{
                class:'d-flex justify-content-between align-self-center participant-in-this-space',
                html:[
                    participant,
                    indicatiors,
                    actions
                ]
            })

            const participantMenuContentContainer = $("<div/>", {
                html: [participantEmail, participantRole]
            })

            const participantItemContainer = $("<div/>", {
                class: "participant-item-conatiner col-md-8",
                html:  [participantItem,participantMenuContentContainer]
            })

            const  menuContainer = $("<div/>", {
                class: "menu-container d-flex mb-4",
                html: [participantItemContainer, participantThumbnail]
            })

            PARTICIPANTS.push(menuContainer)

        }
        const noOneInsideOfThisSpace = $("<h6/>", {
            class: "no-participant-title",
            html: "Empty Space"
        })
        if(PARTICIPANTS.length){
            $("#left-menu-participants").html(PARTICIPANTS);
        }else {
            $("#left-menu-participants").html(noOneInsideOfThisSpace);
        }
    }

    createLeftMenuOptions(){
        $("#left-menu-space-name").html(this.getName())
        const ITEMS = [];
        // <h6 class="text-white/95 space-options-item mb-4">Enter Space</h6>
        //             <h6 class="text-white/95 space-options-item mb-4">Chatter Off</h6>
        //             <h6 class="text-white/95 space-options-item mb-4">Edit name</h6>
        //             <h6 class="text-white/95 space-options-item mb-4">Move to Lobby</h6>
        //             <h6 class="text-danger space-options-item mb-4">Unpin Space</h6>
        const enterLeaveSpace = $("<h6/>",{
            class:`${this.id == CONV_STORAGE.myConversation ? 'text-muted pointer-none' : 'text-white/95'} space-options-item mb-4`,
            html:`Enter Space`
        }).on('click', () => {
            if(this.id == CONV_STORAGE.myConversation){
                return
            }
            this.closeLeftSpaceMenu();
            if(lockFocus.isLocked() && !permissions.hasSpacesLock()) {
                CONV_STORAGE.isJoining=false;
                lockFocus.showLockFocusNotification();
                return;
            }
            // if(this.id = CONV_STORAGE.myConversation){
            //     if(permissions.leaveFallbackAssigned()
            //     && permissions.initialSpace()
            //     && CONV_STORAGE.spaceExists(permissions.initialSpace())
            //     && permissions.initialSpace() != CONV_STORAGE.myConversation){
            //         CONV_STORAGE.joinSpace(permissions.initialSpace());
            //     }else{
            //         CONV_STORAGE.leaveSpace();
            //     }
            // }
            if(this.id != CONV_STORAGE.myConversation){
                this.onJoinSpace();
            }

        });

        ITEMS.push(enterLeaveSpace);


        //chatter menu item
        const chatterToggle = $("<h6/>",{
            class:'text-white/95 space-options-item mb-4',
            html:`${volumeManager.masterMuted == 0 ? 'Chatter On' : 'Chatter Off'}`
        }).on('click',()=>{
            volumeManager.toggleChatter();
            chatterToggle.html(`${volumeManager.masterMuted == 0 ? 'Chatter On' : 'Chatter Off'}`)
        });
        ITEMS.push(chatterToggle);

        const privateToggle = $("<h6/>",{
            class:'text-white/95 space-options-item mb-4',
            html:`${this.isPrivate() ? 'Make Space public' : 'Make Space private'}`
        }).on('click',()=>{
            if(this.id === CONV_STORAGE.myConversation){
                this.closeLeftSpaceMenu();
                CONV_STORAGE.makePrivateButtonHandler();
            }
        });

        ITEMS.push(privateToggle);

        //edit name options
        const editName = $("<h6/>",{
            class:'text-white/95 space-options-item mb-4',
            html:`Edit name`
        }).on('click',()=>{

        });
        ITEMS.push(editName);

        //edit pin options
        const togglePin = $("<h6/>",{
            class:'text-white/95 space-options-item mb-4',
            html:`${this.conv_type == 'pinned' ? 'Unpin Space' : 'Pin Space'}`
        }).on('click', ()=>{
            if(this.conv_type === "pinned"){
                this.unPinConversation();
            }else{
                this.pinConversation();
            }
            togglePin.html(`${this.conv_type == 'pinned' ? 'Unpin Space' : 'Pin Space'}`)
        });
        ITEMS.push(togglePin);


        $("#left-space-options").html(ITEMS);

    }
    createDropDownMenuOptions(){
            const PARTICIPANTS=[];
            for (let index = 0; index < this.participants.length; index++) {
                const participants = this.participants
                const pid = this.participants[index];
                let p = kinoParticipants.get(pid);
                const participant = $("<h6/>",{
                    class:'text-white/95 mb-4 space-options-item ellipsis',
                    html:p.getName()+`${p.local ? ' (me)':''}`
                })

                const participantThumbnail = $("<div/>", {
                    class: "participant-video-container",
                    html: this.renderMenuParticipantThumbnail(p)
                })

                const email = p.local ? localStorage.getItem("displayEmail") : p.email;
                const role = p.local ? getKinoRole(): p.role;
                const participantEmail = $("<h6/>", {
                    class: "participant-information ellipsis",
                    attr: {
                        "data-original-title": email,
                        "data-placement": "top",
                        "title": "",
                        "data-toggle": "tooltip"
                    }
                });

                if (email) {
                    participantEmail.html(`Email: <a target="_blank" href="mailto:${email}">${email}</a>`);
                } else {
                    participantEmail.text("Email: No email");
                }

                const participantRole = $("<h6/>", {
                    html: `Role: ${role}`,
                    class: "participant-information participant-role"
                })


                const menuContent = $("<div/>", {
                    class: "menu-content",
                })

                const actions = $('<span/>',{
                    class: "option-icon-container",
                    html:  OptionsDots,
                }).on("click", () => {
                    if (menuContent.is(":visible")) {
                        menuContent.addClass("fadeOut")
                        setTimeout(() => {
                            menuContent.removeClass("fadeOut")
                            menuContent.remove();
                            participantMenuContentContainer.html([participantEmail,participantRole])
                          }, 400);

                    } else {
                        if(!p.local){
                            participantMenuContentContainer.html(menuContent)
                            Video.renderParticipantMenu(p.id, menuContent,p)
                        }else{
                            participantMenuContentContainer.html(menuContent)
                            Video.renderLocalParticipantMenu(menuContent)
                        }
                    }
                })

                let isCameraMutedOnTile = p.local ? isCameraMuted() : Video.videos[p.id].isVideoMuted()
                let isMicMutedOnTile = p.local ? isMicMuted() :  Video.videos[p.id].hasMicMuted


                let micMuted = $('<div/>', {
                    class: `in-video-mic-muted mic-status-${p.local ? "local" :p.id} cursor-pointer ${isMicMutedOnTile || "d-none"}`,
                    html: this.micMutedIcon
                })

                let cameraMuted = $('<div/>',{
                    class: `in-video-camera-muted camera-status-${p.local ? "local" :p.id} cursor-pointer ${isCameraMutedOnTile || "d-none"}`,

                    html: this.cameraMutedIcon
                });

                let indicatiors = $("<div/>", {
                    class: "space-menu-tiles-indicators",
                    html: [micMuted,cameraMuted]
                }
                )

                const participantItem = $("<div/>",{
                    class:'d-flex justify-content-between align-self-center participant-in-this-space',
                    html:[
                        participant,
                        indicatiors,
                        actions
                    ]
                })

                const participantMenuContentContainer = $("<div/>", {
                    html: [participantEmail, participantRole]
                })

                const participantItemContainer = $("<div/>", {
                    class: "participant-item-conatiner col-md-8",
                    html:  [participantItem,participantMenuContentContainer]
                })

                const  menuContainer = $("<div/>", {
                    class: "menu-container d-flex mb-4",
                    html: [participantItemContainer, participantThumbnail]
                })

                PARTICIPANTS.push(menuContainer)

            }

            const noOneInsideOfThisSpace = $("<h6/>", {
                class: "no-participant-title",
                html: "Empty Space"
            })
            if(PARTICIPANTS.length){
                this.dropDownSpaceOption.find(".menu-body").html(PARTICIPANTS);
            }else {
                this.dropDownSpaceOption.find(".menu-body").html(noOneInsideOfThisSpace);
            }
    }
    getName(){
        if (!this.name || this.name.length == 0) {
            return this.conv_type=="pinned" ? "Pinned Space" : "Focused Space";
        }
        return this.name
    }

    addToNewPanel(){
        let sv=this;

        if (!this.name || this.name.length == 0) {
            this.name = this.conv_type=="pinned" ? "Pinned Space" : "Focused Space";
        }

        sv.tiles = $('<div/>',{
            style:`width:${spacesView.spaceWidth}px;min-height:${spacesView.getTileHeight()}px;max-height:${spacesView.getTileHeight()}px;`,
            class: 'lobby-tiles',
        });
        const tilesContainer = $("<div/>",{
            class:'lobby-tiles-container lobby-tiles-container-expanded-view',
            id:'sideBarLobbyTiles',
            html:sv.tiles
        })

        let clickCount = 0;
        let clickTimeout;


        const prviteSpaceIcon = $("<div />", {
            class: "private-space-icon-conatiner",
            html: `<svg width="25px" height="27px" viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_f_2358_436)">
            <path d="M31.3189 18.233C30.865 17.8352 30.3143 17.6365 29.6659 17.6365H28.8885V13.5453C28.8885 10.9318 27.8194 8.68764 25.6804 6.81263C23.5415 4.93754 20.9818 4 17.9999 4C15.0181 4 12.4578 4.93754 10.3191 6.81255C8.18013 8.68764 7.11096 10.9317 7.11096 13.5453V17.6365H6.33328C5.68535 17.6365 5.13429 17.8352 4.68054 18.233C4.22679 18.6304 4 19.1135 4 19.682V31.9546C4 32.5226 4.22688 33.0058 4.68054 33.4037C5.13429 33.801 5.68535 34 6.33328 34H29.6665C30.3149 34 30.8655 33.8013 31.3195 33.4037C31.7728 33.0058 32 32.5226 32 31.9546V19.6818C32.0003 19.1137 31.7728 18.6307 31.3189 18.233ZM24.222 17.6365H11.7777V13.5453C11.7777 12.0397 12.3855 10.7541 13.6007 9.68898C14.8161 8.62368 16.2824 8.09114 18.0001 8.09114C19.718 8.09114 21.184 8.62361 22.3995 9.68898C23.6144 10.7541 24.222 12.0397 24.222 13.5453V17.6365Z" fill="white"/>
            </g>
            <defs>
            <filter id="filter0_f_2358_436" x="0" y="0" width="36" height="38" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
            <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
            <feGaussianBlur stdDeviation="2" result="effect1_foregroundBlur_2358_436"/>
            </filter>
            </defs>
            </svg>
            `
        })

        const privateSpaceTitle = $("<h6 />", {
            html: `Private Space`
        })

        this.privateSpaceLayer = $("<div/>", {
            class: `private-space-layer ${this.is_private || "d-none"}`,
            html: [prviteSpaceIcon,privateSpaceTitle]
        })

        const spaceBody = $("<div/>", {
            class: 'box-body bg-blur-widget position-relative',
            html: [sv.isLobby() ? tilesContainer : sv.tiles, this.privateSpaceLayer]
        }).on('click', () => {
            if (clickTimeout) {
                clearTimeout(clickTimeout);
                clickTimeout = null;
                this.onJoinSpace();
                this.leftSpaceMenu.removeClass("open")
                this.leftSpaceMenu.addClass("done")
            } else {
                clickTimeout = setTimeout(() => {
                    // This is a single click
                    clickTimeout = null;
                    if ($("#side-spaces-drawer").hasClass("spaces-panel-expanded")) {
                        this.openDropDownMenu()
                    } else {
                        this.toggleLeftMenu()
                    }
                }, 500); // Adjust the timeout duration as needed
            }
        });

        sv.isEscClicked = false

        sv.spaceInput = $("<input/>", {
            class: "edit-space-name d-none",
            maxlength: 25,
        }).on("keydown", (e) => {
            if(e.which === 27) {
                sv.isEscClicked = true
                sv.cancelNameChange()
            }
        }).on("blur", () => {
            if(!sv.isEscClicked){
               this.saveName()
            }
        }).on("keypress", (e) => {
            let code = e.keyCode || e.which;
            if (code == 13) {
                this.saveName();
            }
        })


        sv.spaceName = $('<h5/>',{
            class: 'text-white/95 spaceName ellipsis mb-0',
            tabindex: 0,
            html: this.name
        }).on("click", () => {
            sv.makeNameEditable();
        }).on("mouseover", () => {
            if (!permissions.isMod() && !permissions.hasSpacesManager()) {
                sv.spaceName.attr("data-original-title", "You don't have permissions to edit the space name");
                sv.spaceName.attr("data-placement", "top");
                sv.spaceName.attr("title", "");
                sv.spaceName.attr("data-toggle", "tooltip");
            } else {
                // Remove attributes when in the else block
                sv.spaceName.removeAttr("data-original-title");
                sv.spaceName.removeAttr("data-placement");
                sv.spaceName.removeAttr("title");
                sv.spaceName.removeAttr("data-toggle");
            }
        })

        sv.spaceNameSpanIcon = $("<span/>", {
            class: "space-name-icon",
            html: sv.spaceNameIcon
        })

        sv.spaceNameContainer = $("<div/>", {
            class: "space-name-conatiner",
            html: [sv.spaceNameSpanIcon,sv.spaceName]
        })

        sv.spaceOptions = $("<span/>",{
            class:'ml-1 space-header-btn',
            html: OptionsDots
        }).on('click',()=>{
            if($("#side-spaces-drawer").hasClass("spaces-panel-expanded")){
                this.openDropDownMenu();
            } else {
                this.toggleLeftMenu();
            }
        })
        console.log("sv.isPinned()",sv.isPinned())
        sv.pinnedButton = $("<span/>", {
            class: `space-header-btn ${sv.isPinned() ? "pinned-icon" : ""}`,
            html: CONV_STORAGE.pinIcon
        }).on("click", () => {
            if (sv.isPinned()) {
                // sv.setSpaceOrder(4);
                sv.pinnedButton.removeClass("pinned-icon");
                sv.container.removeClass("pinned-space");
                sv.storeUnpinSpace()
                spacesView.orderNonPinnedSpaces();
            } else {
                sv.pinnedButton.addClass("pinned-icon");
                sv.container.addClass("pinned-space");
                sv.storePinSpace()
                // sv.setSpaceOrder(2);
                spacesView.orderPinnedSpaces();
            }
        });


        sv.spaceHeaderContent = $("<div/>",{
            class:'space-header-content',
            html:[sv.spaceNameContainer, sv.pinnedButton
            ]
        })
        sv.spaceHeader = $("<div/>",{
            class: 'align-items-center box-header d-flex justify-content-between mb-1',
            html:[sv.spaceHeaderContent, sv.spaceInput,]
        })

        sv.chatterButton = $("<div/>",{
            class:'btn-blur space-chatter-btn',
            'data-toggle':"tooltip",
            'data-placement':"top",
            'original-title':"Mute",
            html:VolumeIcon
        }).on('click',()=>{
            if(sv.isChatterLocked()){
                return
            }
            if(sv.volume===0){
                this.unMute()
            }else{
                sv.setVolume(0)
            }
        });


        sv.volumePercentage = $("<span/>",{
            class:"volume-percentage-text",
            html:"5%"
        })

        this.runnable = $("<span/>",{
            class:'slider-runnable'
        });
        adjustSlider(this.runnable[0],0.05);
        sv.volumeSlider = $("<input/>",{
            id:'sideBarVolumeRange',
            type:"range",
            min:"0",
            max:"1",
            value:0.05,
            step:"0.01"
        }).on('input',()=>{
            if(sv.isChatterLocked()){
                return
            }
            sv.setVolume(sv.volumeSlider.val(),false)
        })
        sv.volumeSlider.val(0.05)
        if(sv.isChatterLocked()){
            sv.volumeSlider.attr('disabled',true)
        }
        const sliderWrapper=$("<div/>",{
            class:'volume-slider-wrapper',
            html:[this.volumeSlider,this.runnable]
        })
        const volumeSliderContainer = $("<div/>",{
            class:'d-flex align-items-center w-100',
            html:[sliderWrapper,"&nbsp;",this.volumePercentage]
        })

        sv.spaceNameHeading = $("<h6/>", {
            class: "space-name-heading ellipsis",
            html: this.getName()
        })

        const closeIconMenu = $("<span/>", {
            html: this.closeDropDownMenuIcon
        }).on("click", () => {
            this.openDropDownMenu()
        })

        const menuHeader = $("<div/>", {
            class: "menu-header",
            html: [sv.spaceNameHeading, closeIconMenu]
        })

        const menuBody = $("<div/>", {
            class: "menu-body",
        }).on('scroll',Video.efss.inViewportSpaceMenu.bind(Video.efss,false))

        this.buttonTitle = $("<h6/>", {
            class: "text-white/95 mb-0 ml-2",
            html: "Delete space"
        });

        this.removeSpaceButton = $("<button/>", {
            class: "btn-blur box-header d-flex justify-content-center align-self-center red-btn-shadow",
            html: [this.removeButtonIcon, this.buttonTitle]
        }).on("click", () => {
            this.unPinConversation();
        });

        this.removeButtonConatiner = $("<div/>", {
            class: "remove-space-button-conatiner-drop-down",
            html: (permissions.isMod() && !permissions.hasSpacesManager()) && this.removeSpaceButton
        })

        const peopleInThisSpaceButton = $("<span/>",{
            class: "align-self-center d-flex justify-content-between my-2 space-panel-expanded-title text-left w-100",
            html: "People in Space"
        })

        const enterButtonDropDown = $("<button/>", {
            class: "btn btn-blur enter-btn mt-2 mb-1",
            html: "Enter Space",
            id: "enterBtnLeftSide"
        }).on("click", () => {
            this.onJoinSpace()
            $(".drop-down-space-menu").addClass("d-none")
        })


        const menuOptions = $("<div/>", {
            class: "people-in-this-space d-flex align-item-center flex-column",
            html: [ enterButtonDropDown, peopleInThisSpaceButton]
        })

        this.dropDownSpaceOption = $("<div/>",{
            class:'drop-down-space-menu d-none',
            id: `dropDownMenuOption-${this.id}`,
            html: [menuHeader,menuOptions, menuBody, this.removeButtonConatiner]
        })

        // this.dropDownMenu = dropDownSpaceOption

        const spaceFooter = $("<div/>",{
            class:'d-flex align-items-center volume-range-conatiner',
            html:[sv.chatterButton,volumeSliderContainer]
        })


        // let tileheight=spacesView.getSpaceTileHeight();

        const spaceBodyContainer = $("<div/>",{
            class:'body-layout-conatiner',
            html:[spaceBody,spaceFooter,this.dropDownSpaceOption]
        });


        let tileHeight=spacesView.getSpaceTileHeight();
        // sv.addMyConversationLayer();
        sv.container = $('<div/>',{
            class: `${sv.isLobby() ? 'space-panel-box-lobby' : 'space-panel-box'} mb-3 noselect position-relative ${sv.isPinned() ? "pinned-space" : ""}`,
            style: `width:${spacesView.getSpaceTileWidth()}px;min-height:${tileHeight.min}px;max-height:${tileHeight.max}px`,
            html: [sv.spaceHeader,spaceBodyContainer]
        });

        if(sv.isLobby()){
            spacesView.lobbyContainer.html(sv.container);
        }else{
            spacesView.spacesContainer.append(sv.container);
        }
        // Check if the space is pinned
        if (sv.isPinned()) {
            spacesView.orderPinnedSpaces();
        } else {
            spacesView.orderNonPinnedSpaces();
        }

    }

    isChatterLocked(){
        return Video.lockMasterVolume.isLocked() && this.id != CONV_STORAGE.myConversation && this.volume == 0
    }

    addOrUpdatePinAccess(){
        try {
            if(!this.pinAction){
                this.pinAction = $('<button/>',{
                    class: 'unpin-button',
                    html: this.conv_type == "pinned" ? spacesView.unpinIcon : spacesView.pinIcon,
                    title: this.conv_type == "pinned" ? 'Unpin this space' : 'Pin this space'
                }).on('click', ()=>{
                    if(this.conv_type === "pinned"){
                        this.unPinConversation();
                    }else{
                        this.pinConversation();
                    }
                });
                this.modActions.prepend(this.pinAction);
            }
        } catch (error) {

        }
    };

    setSpaceNameEvents(){
        this.editAction = $('<button/>',{
            class: 'rename-button',
            html: spacesView.editIcon,
            title: "Edit space name",
            "data-toggle": "tooltip",
            "data-placement": "top",
        }).on('click', ()=>{
            this.isSaving = false;
            this.makeNameEditable();
            this.modActions.addClass("editNameStaticOpacity");
        });
        this.modActions.append(this.editAction);


        let savename = $("<span/>", {
            class: "save-name",
            html: `<i class="fas fa-check"></i>`,
        }).on("click", (e)=>{
            this.isSaving = true;
            this.saveName();
            this.modActions.removeClass("editNameStaticOpacity"); // card id 836
        });

        let cancelname = $("<span/>", {
            class: "cancel-name",
            html: `<i class="fas fa-times"></i>`,
        }).on("click",() => {
            this.isSaving = false;
            this.cancelNameChange();
            this.modActions.removeClass("editNameStaticOpacity"); // card id 836
        });

        let cnameAction = $("<div/>", {
            class: "name-action",
            html: [savename, cancelname],
        });
        this.modActions.append(cnameAction);

        //events

        this.conversationName.on("click", (event) => {
            console.log(this.modActions);
            this.modActions.addClass("editNameStaticOpacity"); // card id 836
            if (!$(event.currentTarget).hasClass("editing")) {
                this.makeNameEditable();
            }
        })
        .on("paste", (e) => {
            let conv_name = sanitizeHtml(
                this.conversationName.html(),
                this.sanitizeOptions
            );
            if (
                (conv_name + event.clipboardData.getData("text/plain"))
                    .length >= 24
            ) {
                return false;
            }
        })
        .on("keypress", (e) => {
            let code = e.keyCode || e.which;
            if (code == 13) {
                this.saveName();
                return;
            }
            let conv_name = sanitizeHtml(
                this.conversationName.html(),
                this.sanitizeOptions
            );
            if (
                conv_name.length > 24 &&
                window.getSelection().toString().length === 0
            ) {
                if (code != 8 && code != 9 && code != 37 && code != 39 && !(code == 88 && e.ctrlKey) ) {
                    e.preventDefault();
                    return false;
                }
            }
        })
        .on("focusout", (e) => {
            if ($(document.activeElement).hasClass("conversation-name"))
                return false; // card 441
            this.makeNameEditableMouseOutTimeout = setTimeout(() => {
                if (!this.isSaving) {
                    this.cancelNameChange();
                    this.modActions.removeClass("editNameStaticOpacity"); // card id 836
                }
            }, 500);
        });

    };

    addMyConversationLayer(){
        this.leavebtn = $("<button/>", {
            class: `btn btn-sm btn-outline-danger btn-rounded mt-1 leave-conversationBtn noselect`,
            html: `Leave Space`
        }).on('click', () => {

            if(lockFocus.isLocked() && !permissions.hasSpacesLock()) {
                CONV_STORAGE.isJoining=false;
                lockFocus.showLockFocusNotification();
                return;
            }
            this.myconversationOverlay.removeClass('visible');
            if(permissions.leaveFallbackAssigned()
                && permissions.initialSpace()
                && CONV_STORAGE.spaceExists(permissions.initialSpace())
                && permissions.initialSpace() != CONV_STORAGE.myConversation){
                    CONV_STORAGE.joinSpace(permissions.initialSpace());
                }else{
                    CONV_STORAGE.leaveSpace();
                }
        });

        this.myconversationOverlay = $("<div/>", {
            class: "conversation-overlay",
            html: this.leavebtn,
        });
        this.tilesWrapper.append(this.myconversationOverlay);
    }


    async unPinConversation() {
        if (!CONV_STORAGE.canPin()) {
            return;
        }
        CONV_STORAGE.conversationUnPinned(this.id);
        socket.sendBroadcastMessage({
            eventName: "ConversationUnpin",
            data: {
                conversation_id: this.id
            }
        });
        axios.post(convertPath(`/conversation/unpin/${this.id}`),{},await electronConfig()).then((response) => {
            if (response.data.status) {
                // console.log(response.data.status);
                $("#add-conversation-modal").modal("hide");
                $("#new-conversation-name-input").val("");
            }
        });
    };

    async pinConversation() {
        if (!CONV_STORAGE.canPin()) {
            return;
        }
        CONV_STORAGE.conversationPinned(this.id);
        socket.sendBroadcastMessage({
            eventName: "ConversationPin",
            data: {
                conversation_id: this.id,
            }
        });
        axios.post(convertPath(`/conversation/pin/${this.id}`),{},await electronConfig()).then((response) => {
            if (response.data.status) {
                // console.log(response.data.status);
                $("#add-conversation-modal").modal("hide");
                $("#new-conversation-name-input").val("");
            }
        });
    }

    setVolume(volume,updateSlider=true){
        if(updateSlider){
            this.volumeSlider.val(volume);
        }
        if(volume > 0) this.lastVolume=volume;
        this.volume = volume;
        this.updateSliderUI()
        for (let index = 0; index < this.participants.length; index++) {
            const pid = this.participants[index];
            let p = kinoParticipants.get(pid);
            if(p && !p.local){
                p.setVolume(volume);
            }
        }
    }

    unMute(){
        const lastVolume = this.lastVolume ? this.lastVolume : CONV_STORAGE.myConversation == this.id ? 1 : 0.05;
        this.setVolume(lastVolume)
    }

    updateSliderUI(){
        adjustSlider(this.runnable[0],this.volumeSlider.val());
        this.volumePercentage.html(`${Math.floor(this.volumeSlider.val() * 100)}%`)
        if(this.isChatterLocked()){
            this.volumeSlider.attr('disabled',true)
        }else{
            this.volumeSlider.removeAttr('disabled')
        }
        if(this.volumeSlider.val() == 0){
            this.chatterButton.html(Video.volumeIconMuted);
        }else{
            this.chatterButton.html(Video.volumeIcon);
        }
    }

    removeSpace(){
        try {
            stopMediaPlayers(this.tiles);
            this.tiles.remove();
            this.container.remove();
        } catch (error) {

        }
    };

    setSpaceOrder(order){
        this.container.css("order", order);
    }
};

